<template>
<video :src="baseUrl+src" :poster="baseUrl+poster" ref="video"></video>
</template>

<script>
import videojs from 'video.js/dist/alt/video.core.novtt.js';

export default {

    name: "VideoJs",

	data(){
		return {
			baseUrl:"/"
		}
	},

    props: {
        src: "",
        poster: "",
        clickFullscreen: {
            type: Boolean,
            default: false
        },
    },

    mounted() {


		this.baseUrl = process.env.BASE_URL;


        var videoElement = this.$refs.video;
        var source = this.baseUrl + this.src;
        var poster = this.baseUrl + this.poster;
        videoElement.removeAttribute("poster");
        videoElement.removeAttribute("src");
        videoElement.classList.add("video-js");
        videoElement.classList.add("vjs-16-9");
        videoElement.classList.add("vjs-big-play-centered");
        var videoOptions = {
            autoplay: false,
            controls: true,
            fluid: false,
            preload: "auto",
            sources: [{
                src: source,
                type: "video/mp4"
            }],
            poster: poster,
            controlBar: {
                pictureInPictureToggle: false,
            }

        }

        if (poster && poster.includes("api/1/attachment")) {
            videoOptions.poster = poster;
        }

        if (this.clickFullscreen) {
            // Clicking the video toggles fullscreen instead of play/pause.
            // Disable doubleClick so it doesn't fight the single-click handler.
            videoOptions.userActions = {
                doubleClick: false,
                click: function() {
                    // `this` is bound to the video.js player.
                    if (this.isFullscreen()) {
                        this.exitFullscreen();
                    } else {
                        this.requestFullscreen();
                    }
                }
            };
        }

        videojs(videoElement, videoOptions, function onPlayerReady() {});

    },

}
</script>
